import { FC } from 'react';
import { AgentNetConfirmationDialog } from 'ui-kit/components/modal/ConfirmationDialog';

export interface DisableConfirmDialogProps {
  open: boolean;
  testIdPrefixDialog: string;
  updateServiceStatus: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

const DISABLE_CONFIRM_TEXT =
  'The Title Monitoring enrollment QR code will no longer be included on eligible owner policies. ' +
  'Buyers who have already enrolled will continue to receive alerts and have access to the Title Monitoring dashboard.';

export const DisableConfirmDialog: FC<DisableConfirmDialogProps> = ({
  open,
  testIdPrefixDialog,
  updateServiceStatus,
  onClose,
  onConfirm,
}) => (
  <AgentNetConfirmationDialog
    qaAttrPrefix={`${testIdPrefixDialog}confirm`}
    onConfirm={onConfirm}
    disablePrimaryBtn={updateServiceStatus === 'pending'}
    open={open}
    onDismissAction={onClose}
    dialogTitle="Disable Add-On?"
    dialogBtnContent="Yes, Disable"
    secondaryActionBtnContent="Cancel"
    dialogText={DISABLE_CONFIRM_TEXT}
  />
);
